import {ProfileCreationFunnelMode} from '@/profile-creation-wizard/config/steps/ProfileCreationSteps';
import {Router} from 'vue-router';

export class StepNavigator {
    private router: Router;
    private readonly previousStepName: string | undefined;
    private readonly nextStepName: string | undefined;

    constructor(router: Router, previous?: string, next?: string) {
        this.router = router;
        this.previousStepName = previous;
        this.nextStepName = next;
    }

    previous() {
        if (this.previousStepName) {
            this.routerPush(this.previousStepName);
        }
    }

    next() {
        if (this.nextStepName) {
            this.routerPush(this.nextStepName);
        }
    }

    nextHref(): string {
        return this.router.resolve({name: this.nextStepName}).href;
    }

    private routerPush(stepName: string) {
        const query = {};

        if (this.isMaltStrategyRoute(stepName)) {
            query['maltStrategy'] = 'true';
        }

        this.router.push({name: stepName, query: query});
    }

    private isMaltStrategyRoute(stepName: string): boolean {
        if (this.router.hasRoute(stepName)) {
            const filteredRoutes = this.router.getRoutes().filter((route) => route.name === stepName);

            if (filteredRoutes.length === 1) {
                if (filteredRoutes[0].meta && filteredRoutes[0].meta.funnelMode === ProfileCreationFunnelMode.STRATEGY) {
                    return true;
                }
            }
        }

        return false;
    }
}
